export default __webpack_public_path__ + "static/media/logo.70a1e467.png";